export class Charm {
  id: number
  x: number
  y: number
  image: string

  constructor (id: number, image: string, x: number, y: number) {
    this.id = id
    this.image = image
    this.x = x
    this.y = y
  }
}
